import { API_URL } from "../config"
import { getToken } from "../util/validation";

const token = JSON.parse(getToken);

export async function getDomainDetails(letter) {

    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'letter': letter
        }

        const response = await fetch(API_URL + 'adminpanel/get_domain_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }

}

export async function getAccountsHistory(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_account_history_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getGetSupportTicket(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_support_ticket_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getDeploymentTicket(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_deployment_ticket_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getCustomerCount() {
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
        }

        const response = await fetch(API_URL + 'adminpanel/get_customer_count/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getResellerCount() {
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
        }

        const response = await fetch(API_URL + 'adminpanel/get_reseller_count_shiviom/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
    
}

export async function getDomainRenewalData(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_domain_renewal_data/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getRenewalHistoryData(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_history_data/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getDomainStatusDetails(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_domain_status_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getDomainOutstandingDetails(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_domain_account_outstanding_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}


export async function getDomainContactDetails(domain_name){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'domain_name': domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/get_domain_contact_detail/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getSearchDomain(search, tabValue){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'tabValue': tabValue,
            'search': search
        }

        const response = await fetch(API_URL + 'adminpanel/get_search_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getAllResellerDetails(letter){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'letter': letter
        }

        const response = await fetch(API_URL + 'adminpanel/get_resellersdetails_shiviom/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}


export async function getTopOutstandingDomains(search){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'search': search
        }

        const response = await fetch(API_URL + 'adminpanel/get_top_outstanding_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getUpcomingRenewals(search){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'search': search
        }

        const response = await fetch(API_URL + 'adminpanel/get_upcoming_renewals_dashboard/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getDeploymentTicketsStatus(){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_deployment_tickets_status/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}


export async function getSupportTicketsStatus(){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_support_tickets_status/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getDeploymentTicketStatusList(status){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'status': status
        
        }

        const response = await fetch(API_URL + 'adminpanel/get_deployment_tickets_status_list/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getSupportTicketStatusList(status){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'status': status
        
        }

        const response = await fetch(API_URL + 'adminpanel/get_support_tickets_status_list/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getDomainContactDetailsShiviom(reseller_email){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'reseller_email': reseller_email
        
        }

        const response = await fetch(API_URL + 'adminpanel/get_domain_contact_detail_shiviom/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}